import Vue from "vue";
import {
  Button,
  Form,
  FormItem,
  Input,
  Message,
  Container,
  Header,
  Aside,
  Main,
  Menu,
  Submenu,
  MenuItem,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  Row,
  Col,
  Table,
  TableColumn,
  Switch,
  Tooltip,
  Pagination,
  Dialog,
  Calendar,
  MessageBox,
  Tag,
  Tree,
  Select,
  Option,
  Cascader,
  Alert,
  Tabs,
  TabPane,
  Step,
  Steps,
  Upload,
  Checkbox,
  CheckboxGroup,
  Timeline,
  TimelineItem,
  Divider,
  RadioGroup,
  Radio,
  Carousel,
  CarouselItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Popconfirm,
  Progress,
  Loading,
  Collapse,
  CollapseItem,
  Rate,
  InputNumber,
  RadioButton,
  CheckboxButton
} from "element-ui";
Vue.use(Rate);
Vue.use(RadioButton);
Vue.use(CheckboxButton);
Vue.use(InputNumber);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Progress);
Vue.use(DropdownItem);
Vue.use(Popconfirm);
Vue.use( DropdownMenu);
Vue.use(Dropdown);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Button);
Vue.use(Divider);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Card);
Vue.use(Row);
Vue.use(Col);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Switch);
Vue.use(Tooltip);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Calendar);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Select);
Vue.use(Option);
Vue.use(Cascader);
Vue.use(Alert);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(MenuItem);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Upload);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$loading = Loading;
